module.exports = __webpack_public_path__ + "static/media/89.9e5f77a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/89.svg
// module id = 174
// module chunks = 0